import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ComponentCard from "../../../../components/common/ComponentCard";
import Label from "../../../../components/form/Label";
import Input from "../../../../components/form/input/InputField";
import Select from "../../../../components/form/Select";
import Checkbox from "../../../../components/form/input/Checkbox";
import Switch from "../../../../components/form/switch/Switch";
import Button from "../../../../components/ui/button/Button";

type ItemType = "Packs" | "Pieces" | "Eggs" | "Bottles";

export default function AddNewProduct() {
  const [selectedOption, setSelectedOption] = useState<string>("Free");
  const [isChecked, setIsChecked] = useState(false);
  const [onDeliverySelect, setOnDeliverySelect] = useState("");
  const [typeOfItemsInPackage, setTypeOfItemsInPackage] = useState<Record<ItemType, boolean>>({
    Packs: false,
    Pieces: false,
    Eggs: false,
    Bottles: false,
  });
  const [quantity, setQuantity] = useState("");
  const [daysToExpiry, setDaysToExpiry] = useState("");
  const [productType, setProductType] = useState<string>("");
  const [franchiseMarkup, setFranchiseMarkup] = useState<string>("");
  const [bulkIngredient, setBulkIngredient] = useState(false);
  const [frozenOnCompletion, setFrozenOnCompletion] = useState(false);
  const [useWithin7Days, setUseWithin7Days] = useState(false);
  const [yieldMonitoringRequired, setYieldMonitoringRequired] = useState(false);
  const [starItem, setStarItem] = useState(false);
  const [gst, setGst] = useState(false);
  const [cookedProduct, setCookedProduct] = useState(false);
  const [cutType, setCutType] = useState("");
  const [brandLogo, setBrandLogo] = useState("");
  const [kitchenProductionProfitCentre, setKitchenProductionProfitCentre] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission
    console.log("Form submitted:");
    navigate("/products"); // Navigate back to the Products page
  };

  const handleCancel = () => {
    navigate("/products"); // Navigate back to the Products page
  };

  const optionsProductType = [
    { value: "Standard", label: "Standard" },
    { value: "Core", label: "Core" },
    { value: "Prepared", label: "Prepared" },
  ];
  const categoryOptions = [
    { value: "Bakery", label: "Bakery" },
    { value: "Bar", label: "Bar" },
    { value: "Frozen", label: "Frozen" },
  ];
  const ProductSize = [
    { value: "Kg", label: "Kg" },
    { value: "Liter", label: "Liter" },
    { value: "Unit", label: "Unit" },
  ];
  const ProductOrderType = [
    { value: "Pack", label: "Pack" },
    { value: "Carton", label: "Carton" },
    { value: "Box", label: "Box" },
  ];
  const ItemTypes = [
    { value: "Packs", label: "Packs" },
    { value: "Pieces", label: "Pieces" },
    { value: "Eggs", label: "Eggs" },
    { value: "Bottles", label: "Bottles" },
  ];
  const CutTypes = [
    { value: "Diced", label: "Diced" },
    { value: "Sliced", label: "Sliced" },
    { value: "Chopped", label: "Chopped" },
  ];
  const BrandLogos = [
    { value: "Catering HQ", label: "Catering HQ " },
    { value: "Good & Plenty", label: "Good & Plenty" },
    { value: "Tooti Patisserie", label: "Tooti Patisserie" },
    { value: "Moon Deli", label: "Moon Deli" },
  ];
  const KitchenProductionProfitCentres = [
    { value: "Butchery Production	", label: "Butchery Production	" },
    { value: "Cooked/General Production	", label: "Cooked/General Production	" },
    { value: "Pastry Production", label: "Pastry Production" },
  ];

  const handleSelect = (value: string) => {
    console.log("Selected value:", value);
  };

  const handleTypeOfItemsChange = (item: ItemType) => {
    setTypeOfItemsInPackage((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleExpiryTrackingChange = (value: string) => {
    setOnDeliverySelect(value);
    if (value !== "Packaging Date") {
      setDaysToExpiry("");
    }
  };

  const handleProductTypeChange = (value: string) => {
    setProductType(value);
  };

  return (
    <ComponentCard title="Add new product">
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        {/* Left Column */}
        <div className="space-y-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <div className="space-y-4">
              <div>
                <Label>Product Name</Label>
                <Input type="text"/>
              </div>
              <div>
                <Label htmlFor="firstName">Ingredient Name For Labels</Label>
                <Input type="text" id="firstName" />
              </div>
              <div>
                <Label>Product Type</Label>
                <p className="mt-1 text-xs text-gray-500">
                  Please be aware that once you select one of the below options, this cannot be changed for the product.
                </p>
                <Select
                  options={optionsProductType}
                  placeholder="Select an option"
                  onChange={handleProductTypeChange}
                  // defaultValue=""
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
              </div>
              {(productType === "Core" || productType === "Prepared") && (
                <div>
                  <Label>Franchise Markup</Label>
                  <Input
                    type="number"
                    value={franchiseMarkup}
                    onChange={(e) => setFranchiseMarkup(e.target.value)}
                  />
                </div>
              )}
               {( productType === "Core") && (
                <div>
                  <Label>Central Venue Mark Up</Label>
                  <Input
                    type="number"
                    value={franchiseMarkup}
                    onChange={(e) => setFranchiseMarkup(e.target.value)}
                  />
                </div>
                )}
              <div>
                <Label>Product Category</Label>
                <Select
                  options={categoryOptions}
                  placeholder="Select an option"
                  onChange={handleSelect}
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
              </div>
              <div className="mt-4">
                <Label>Sub-Category</Label>
                <Select
                  options={categoryOptions}
                  placeholder="Select an option"
                  onChange={handleSelect}
                  className="dark:bg-dark-900"
                />
              </div>
              <div className="mt-4">
                <Label>Meat Type</Label>
                <Select
                  options={categoryOptions}
                  placeholder="Select an option"
                  onChange={handleSelect}
                  className="dark:bg-dark-900"
                />
              </div>
              {(productType === "Core" || productType === "Standard") && (
                <div className="mt-4">
                  <Label htmlFor="firstName">Brand</Label>
                  <Input type="text" id="firstName" />
                </div>
              )}
              <div className="mt-4">
                <Label htmlFor="firstName">Our Code</Label>
                <Input type="text" id="firstName" />
              </div>
              <div>
                <Label>Total Quantity</Label>
                <Input type="text" id="firstName" />
              </div>
              <div>
                <Label>Quantity Type</Label>
                <Select
                  options={ProductSize}
                  placeholder="Select an option"
                  onChange={handleSelect}
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
              </div>
              {productType === "Prepared" && (
                <div className="space-y-4">
                  <div>
                    <Label>Cut Type</Label>
                    <Select
                      options={CutTypes}
                      placeholder="Select an option"
                      onChange={(value) => setCutType(value)}
                      // defaultValue=""
                      className="mt-2 bg-gray-50 dark:bg-gray-800"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <div className="mt-2">
              <Label htmlFor="firstName">Barcode for Single Item</Label>
              <Input type="text" id="firstName" />
            </div>
            <div className="mt-4">
              <Label htmlFor="firstName">Barcode for Carton/Box</Label>
              <Input type="text" id="firstName" />
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-6">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <div className="space-y-4">
              <Label>Select Only If You Order This Product Within a Pack/Carton/Box:</Label>
              <Select
                options={ProductOrderType}
                placeholder="Select an option"
                onChange={handleSelect}
                // defaultValue=""
                className="bg-gray-50 dark:bg-gray-800"
              />
              <div className="space-y-4">
                <Label>Type of Items in Within Package</Label>
                <Select
                  options={ItemTypes}
                  placeholder="Select an option"
                  onChange={handleSelect}
                  // defaultValue=""
                  className="bg-gray-50 dark:bg-gray-800"
                />
                <div>
                  <Label>Quantity</Label>
                  <Input
                    type="number"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                  
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <div className="space-y-4">
              <Label>Expiry Tracking</Label>
              <Select
                options={[
                  { value: "Packaging Date", label: "Packaging Date" },
                  { value: "Expiry Date", label: "Expiry Date" },
                ]}
                placeholder="Select an option"
                onChange={handleExpiryTrackingChange}
                // defaultValue=""
                className="bg-gray-50 dark:bg-gray-800"
              />
              {onDeliverySelect === "Packaging Date" && (
                <div>
                  <Label>Days to Expiry</Label>
                  <Input
                    type="number"
                    value={daysToExpiry}
                    onChange={(e) => setDaysToExpiry(e.target.value)}
                  
                  />
                </div>
              )}
            </div>
          </div>
          {productType === "Prepared" && (
            <div className="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] ">
              <div className="p-4">
                <div className="space-y-4">
                  <div>
                    <Label>Brand Logo</Label>
                    <Select
                      options={BrandLogos}
                      placeholder="Select an option"
                      onChange={(value) => setBrandLogo(value)}
                      // defaultValue=""
                      className="mt-2 bg-gray-50 dark:bg-gray-800"
                    />
                  </div>
                  <div>
                    <Label>Kitchen Production Profit Centre</Label>
                    <Select
                      options={KitchenProductionProfitCentres}
                      placeholder="Select an option"
                      onChange={(value) => setKitchenProductionProfitCentre(value)}
                      // defaultValue=""
                      className="mt-2 bg-gray-50 dark:bg-gray-800"
                    />
                  </div>
                  <div>
                    <Label>Yield KPI</Label>
                    <Input type="number" id="firstName" />
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <div className="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] ">
            <div className="p-4">
              <Label>Product Status</Label>
              <div className="flex items-center gap-3">
                <Checkbox
                  checked={selectedOption === "Yes"}
                  onChange={(checked) => setSelectedOption(checked ? "Yes" : "No")}
                  label="Available"
                />
                <Checkbox
                  checked={selectedOption === "No"}
                  onChange={(checked) => setSelectedOption(checked ? "No" : "Yes")}
                  label="Unavailable"
                />
              </div>
            </div>
          </div>
          {(productType === "Core") && (
          <div className="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] ">
            <div className="p-4">
              <Label htmlFor="firstName">Approx Weight Per Piece</Label>
              <Input type="number" id="firstName" />
            </div>
            <div className="p-4">
              <Label htmlFor="firstName">Approx Weight Unit</Label>
              <div className="flex items-center gap-3">
                <Select
                  options={ProductSize}
                  placeholder="Select an option"
                  onChange={handleSelect}
                  className="bg-gray-50 dark:bg-gray-800"
                />
              </div>
            </div>
            <div className="p-4">
              <Label htmlFor="firstName">Number Of Pieces</Label>
              <Input type="number" id="firstName" />
            </div>
          </div>
          )}

          {productType === "Prepared" && (
            <>
              <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
                <div className="flex gap-4">
                  <Switch
                    label="Bulk Ingredient"
                    defaultChecked={bulkIngredient}
                    onChange={(checked) => setBulkIngredient(checked)}
                  />
                  
                  <Switch
                    label="Cooked Product"
                    defaultChecked={gst}
                    onChange={(checked) => setGst(checked)}
                  />
                  <Switch
                    label="Yield Monitoring"
                    defaultChecked={yieldMonitoringRequired}
                    onChange={(checked) => setYieldMonitoringRequired(checked)}
                  />
                  <Switch
                    label="Sold By Venues As Recipe"
                    defaultChecked={yieldMonitoringRequired}
                    onChange={(checked) => setYieldMonitoringRequired(checked)}
                  />  
                </div>
              </div>
            </>
          )}

          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <div className="flex gap-4">
              <Switch
                label="Star Item"
                defaultChecked={starItem}
                onChange={(checked) => setStarItem(checked)}
              />
              <Switch
                label="GST"
                defaultChecked={gst}
                onChange={(checked) => setGst(checked)}
              />
              <Switch
                label="Temperature Recording On Delivery"
                defaultChecked={false}
                onChange={() => console.log("Switch is now:", isChecked ? "ON" : "OFF")}
              />
            </div>
          </div>
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
            <div className="flex gap-4">
              <Switch
                label="Use Within 7 Days Once Opened"
                defaultChecked={useWithin7Days}
                onChange={(checked) => setUseWithin7Days(checked)}
              />
              <Switch
                label="Frozen On Completion"
                defaultChecked={frozenOnCompletion}
                onChange={(checked) => setFrozenOnCompletion(checked)}
              />
              <Switch
                label="Include in Central Inventory"
                defaultChecked={gst}
                onChange={(checked) => setGst(checked)}
              />
            </div>
          </div>

          <div className="flex gap-3">
            <Button size="sm" onClick={()=>handleSubmit}>
              Save Changes
            </Button>
            <Button size="sm" variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </ComponentCard>
  );
}